const RESOURCE_NAME = '/xroutes-calculated';
// import axios from "@/api/http-auth";
import config from "@/config";
const baseURL = config.api.baseURL

export default axios => ({
    getAll(routeId, params) {
        let url = `${RESOURCE_NAME}`;
        if(routeId) url = `/xroutes/${routeId}/calculated`;
        return axios.get(url, {params, baseURL});
    },
    find(id, params) {
        return axios.get(`${RESOURCE_NAME}/${id}`, {params, baseURL});
    },
    update(id, data, params) {
        return axios.put(`${RESOURCE_NAME}/${id}`, data, {params, baseURL});
    },
    // create(data, params) {
    //     return axios.post(`${RESOURCE_NAME}`, data, {params, baseURL});
    // },
    // delete(id, params) {
    //     return axios.delete(`${RESOURCE_NAME}/${id}`, {params, baseURL});
    // },
});